import React, { Component } from "react";
import { Box, Select, Text, Input, Flex } from "@chakra-ui/react";
import { formatISO, parseISO, format, add } from 'date-fns';
import _ from "lodash";
import { DatePicker } from "antd";
import LocalStorageService from "../../../services/LocalStorageService";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;



export default class HistorySearchStrip extends Component {

  constructor(props) {
    super(props);
    this.state =
    {
      searchSchema: null,
      selectedObservation: null
    }

    this.localStorageService = new LocalStorageService();

    this.refreshSearchFields = this.refreshSearchFields.bind(this);
    this.showBaseSearchProp = this.showBaseSearchProp.bind(this);
    this.onRangeChange = this.onRangeChange.bind(this);
  }

  componentDidMount()
  {
    if (this.props.currentSchemaId)
    {
      this.refreshSearchFields();
    }
  }

  componentDidUpdate(prevProps)
  {
    if (prevProps.searchParamsKey !== this.props.searchParamsKey)
    {
      this.refreshSearchFields();
    }
   /*
    if (prevProps.currentSchemaId !== this.props.currentSchemaId)
    {
      this.refreshSearchFields();
    }
      */
  }

  refreshSearchFields()
  {
    let searchSchemaId = (this.props.searchParams.schemaId) ? this.props.searchParams.schemaId : this.props.currentSchemaId;
    var schema = this.localStorageService.getSchema(searchSchemaId);
    var searchSchema = schema.search;
    this.setState({searchSchema: searchSchema});
  }


  updateSearchParams(ev) 
  {
    console.log("changing " + ev.target.name + " to " + ev.target.value);
    var newSearchParams = this.props.searchParams; //_.cloneDeep(this.props.searchParams);
    newSearchParams[ev.target.name] = ev.target.value;
    this.props.onSearchParamsChange(newSearchParams);
  }


  onRangeChange(ev){
    console.log("range changed");
    console.log(ev);
    // don't do anything until we get both dates.
    if ((!ev[0]) || (!ev[1])) return;

    var sd = new Date(ev[0].$y, ev[0].$M, ev[0].$D); //, ev[0].$H, ev[0].$m);
    var ed = new Date(ev[1].$y, ev[1].$M, ev[1].$D); //, ev[0].$H, ev[0].$m);
    var newSearchParams = _.cloneDeep(this.props.searchParams);
    newSearchParams["eventStartDate"] = formatISO(sd);
    newSearchParams["eventEndDate"] = formatISO(ed);
    this.props.onSearchParamsChange(newSearchParams);
  }

  showBaseSearchProp(searchProp)
  {
    if (!this.state.searchSchema) return false;
    if (!this.state.searchSchema.baseFields) return false;
    if (!this.state.searchSchema.baseFields.some(b => b.id === searchProp)) return false;
    let baseField = this.state.searchSchema.baseFields.find((bf) => bf.id === searchProp);
    return baseField.components.includes(this.props.parentComponent);
  }


  render() 
  {

    if (this.props.parentComponent === "dashboard")
    {
      var observersList = this.localStorageService.getDataList("userList", this.props.userSession.gcid);
      var observers = observersList.data.data.map((d) => {return {label: d.name, value: d.id}})
      observers.unshift({ label: "ALL", value: "ALL" })
    }
    else 
    {
      var observers = [
        {label: this.props.userSession.uid, value: this.props.userSession.uid},
        {label: "ALL", value: "ALL"}
      ];
    }
  

    var locations =this.props.userSession.locations;
    if (this.props.parentComponent !== "DataApiAccess")
    {
      if (!locations.some((l) => l.id === "ALL"))
      {
        locations.unshift({id: "ALL", value: "ALL"});
      }
    }
  
    const showLocation = (this.props.parentComponent === "DataApiAccess") ? false : this.showBaseSearchProp("location");
    var locationSearchObj = this.state.searchSchema?.baseFields.find(b => b.id === "location");


    const showEventDates = (this.props.parentComponent === "DataApiAccess") ? true : this.showBaseSearchProp("eventStartDate");
    if (showEventDates)
    {
      var eventStartDateTitle = "Date Range";

      if (this.props.parentComponent != "DataApiAccess")
      {
        eventStartDateTitle = this.state.searchSchema.baseFields.find(b => b.id === "eventStartDate").title;
      }
      var st = this.props.searchParams.eventStartDate ?? formatISO(add(new Date(), { days: -5 }));
      var et = this.props.searchParams.eventEndDate ?? formatISO(add(new Date(), { days: 1 }));
      var std = parseISO(st);
      var etd = parseISO(et);
      var stdjs = format(std, "yyyy-MM-dd");
      var etdjs = format(etd, "yyyy-MM-dd");
    }
    const showObserver = (this.props.parentComponent === "DataApiAccess") ? false : this.showBaseSearchProp("observer");

    return (

      // <HStack justify='center'>

      <Flex flexWrap={"wrap"} justifyContent={"space-between"}>
        {(showLocation) ?
        <Box style={{minWidth: "fit-content"}}>
          <Text margin='0' color='white' fontSize='12px'>{(locationSearchObj.label) ? locationSearchObj.label: locationSearchObj.title}</Text>
          <Select
            bg='white'
            value={this.props.searchParams.location}
            name="location"
            id="location"
            key="location"
            onChange={ev => this.updateSearchParams(ev)}
          >
            {locations.map((loc) => (
              <option key={loc.id} value={loc.id}>{loc.id}</option>
            ))}
          </Select>
        </Box>
        : <span/>
        }


        <Box style={{minWidth: "fit-content"}}>
          <Text margin='0' color='white' fontSize='12px'>Schema</Text>
          <Select
            bg='white'
            value={this.props.searchParams?.schemaId?? ""}
            name="schemaId"
            id="schemaId"
            key="schemaId"
            onChange={ev => this.updateSearchParams(ev)}
          >
            {this.props.userSession.schemas.map((schema) => (
              <option key={schema} value={schema}>{schema}</option>
            ))}
          </Select>
        </Box>


        {(showEventDates) ?
        <Box style={{minWidth: "fit-content"}}>
          <Text margin='0' color='white' fontSize='12px'>{eventStartDateTitle}</Text>
          <RangePicker 
          defaultValue={[dayjs(stdjs, 'YYYY-MM-DD'), dayjs(etdjs, 'YYYY-MM-DD')]}
          format='YYYY-MM-DD'
          name="eventStartDate"
          id="eventStartDate"
          key="eventStartDate"
          size='large'
          onCalendarChange={ev => this.onRangeChange(ev)}
          />
        </Box>
        : <span/>
        }
            
        {
          this.state.searchSchema?.searchFields?.map((fld) =>
          {
            if (!fld.components.includes(this.props.parentComponent)) return <span/>;
            if ((fld.dataList))
            {
              var dataList = this.localStorageService.getDataList(fld.dataList, this.props.userSession.gcid);
              fld.options = dataList.data.data.map((d) => {return {label: d.name, value: d.id}})
            }
            if ((fld.options) && (!fld.options.some((opt) => opt.value==="ALL"))) 
            {
              fld.options.unshift({ label: "ALL", value: "ALL" })
            }
            return <Box style={{minWidth: "fit-content"}}>
              <Text margin='0' color='white' fontSize='12px'>{(fld.label) ? fld.label : fld.title}</Text>
              {(fld.options) ?
                <Select
                  bg='white'
                  //value={this.props.searchParams.inspector}
                  value={this.props.searchParams[fld.id]}
                  name={fld.id}
                  key={fld.id}
                  id={fld.id}
                  onChange={ev => this.updateSearchParams(ev)}
                 >
                  {fld.options.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </Select>
                :
                <Input bg='white' key={fld.id} id={fld.id} name={fld.id} onBlur={ev => this.updateSearchParams(ev)}/>

              }
            </Box>
          })
        }

{
          this.state.searchSchema?.childFields?.map((fld) =>
          {
            if (!fld.components.includes(this.props.parentComponent)) return <span/>;
            if ((fld.dataList))
            {
              var dataList = this.localStorageService.getDataList(fld.dataList, this.props.userSession.gcid);
              fld.options = dataList.data.data.map((d) => {return {label: d.name, value: d.id}})
            }
            if ((fld.options) && (!fld.options.some((opt) => opt.value==="ALL"))) 
            {
              fld.options.unshift({ label: "ALL", value: "ALL" })
            }
            return <Box style={{minWidth: "fit-content"}}>
              <Text margin='0' color='white' fontSize='12px'>{(fld.label) ? fld.label : fld.title}</Text>
              {(fld.options) ?
                <Select
                  bg='white'
                  //value={this.props.searchParams.inspector}
                  value={this.props.searchParams[fld.id]}
                  name={fld.id}
                  key={fld.id}
                  id={fld.id}
                  onChange={ev => this.updateSearchParams(ev)}
                 >
                  {fld.options.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </Select>
                :
                <Input bg='white' key={fld.id} id={fld.id} name={fld.id} onBlur={ev => this.updateSearchParams(ev)}/>

              }
            </Box>
          })
        }

        {(showObserver) ?
        <Box style={{minWidth: "fit-content"}}>
          <Text margin='0' color='white' fontSize='12px'>{this.state.searchSchema.baseFields.find(b => b.id === "observer").title}</Text>
          <Select
            bg='white'
            value={this.props.searchParams.observer}
            name="observer"
            id="observer"
            key="observer"
            onChange={ev => this.updateSearchParams(ev)}
          >
            {observers.map((inspector) => (
              <option key={inspector.value} value={inspector.value}>{inspector.label}</option>
            ))}

            {/*
            {observers.map((inspector) => (
              <option key={inspector} value={inspector}>{inspector}</option>
            ))}
            */}
          </Select>
        </Box>
        : <span/>
        }

</Flex>

      // </HStack>



      
    );

  }




}